/* Cart drawer upsell: adds one more pack (on the product's subscription plan when it has one)
   and re-renders the drawer through the theme's own section rendering. */
document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-eo-upsell]');
  if (!button || button.disabled) return;
  const drawer = document.querySelector('cart-drawer');
  button.disabled = true;
  button.classList.add('is-loading');
  const item = { id: Number(button.dataset.variant), quantity: 1 };
  if (button.dataset.plan) item.selling_plan = Number(button.dataset.plan);
  const sections = drawer && typeof drawer.getSectionsToRender === 'function'
    ? drawer.getSectionsToRender().map((s) => s.id)
    : ['cart-drawer', 'cart-icon-bubble'];
  try {
    const res = await fetch(`${(window.routes && window.routes.cart_add_url) || '/cart/add'}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item], sections, sections_url: window.location.pathname }),
    });
    const state = await res.json();
    if (!res.ok || state.status) throw new Error(state.description || 'add failed');
    if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(state);
    else window.location.reload();
  } catch (error) {
    console.error('Cart upsell:', error);
    button.disabled = false;
    button.classList.remove('is-loading');
  }
});
